import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { Button } from 'components/ui/button';

interface RemindButtonProps {
  /** Reminded less than 24 h ago: shown, disabled (E15). */
  cooling: boolean;
  /** The request whose reminder is in flight: its button spins, every other one waits. */
  remindingId: number | null;
  requestId: number;
  onClick: () => void;
}

/** « Relancer » on a pending row, in both drawers — 28 px drawn, 44 px hit area via the pseudo-element. */
const RemindButton = ({ cooling, remindingId, requestId, onClick }: RemindButtonProps) => {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="relative h-7 shrink-0 px-2.5 before:absolute before:-inset-y-2 before:inset-x-0 before:content-['']"
      disabled={cooling || remindingId !== null}
      aria-busy={remindingId === requestId}
      onClick={onClick}
    >
      {remindingId === requestId && <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" aria-hidden="true" />}
      {t('Remind')}
    </Button>
  );
};

export default RemindButton;
